/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/scandipwa
 */

import { isSignedIn as isSigned } from '@scandipwa/scandipwa/src/util/Auth/Token';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import CmsBlock from 'Component/CmsBlock';

import './FooterBottom.style';

/** @namespace Pwa/Component/FooterBottom/Component/mapStateToProps */
export const mapStateToProps = () => ({});

/** @namespace Pwa/Component/FooterBottom/Component/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Pwa/Component/FooterBottom/Component */
export class FooterBottomComponent extends PureComponent {
    render() {
        const isLoggedIn = isSigned();

        if (isLoggedIn) {
            return null;
        }

        return (
            <div block="FooterBottom">
                <CmsBlock identifier="footer_bottom" />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterBottomComponent);
